(function($) {
    if (!document.querySelector('body.gp-endpoint-pos-new-coupon')) {
        return;
    }

    $(document).on('change', '.pos__new_coupon_form input[name="coupon_value"]', function() {
        $('.pos__new_coupon_form__label.selected').removeClass('selected');
        $(this).closest('.pos__new_coupon_form__label').addClass('selected');
    });

    $(document).on('click', '.pos__new_coupon_form-button', function(e) {
        e.preventDefault();

        const $form = $('.pos__new_coupon_form');
        const amount  = $form.find('input[name="coupon_value"]:checked').val();
        const receipt = $form.find('input[name="receipt_number"]').val().trim();

        if (!amount) {
            return alert('Vyberte prosím hodnotu poukazu');
        }

        gp_ajax({
            url:     ghostpress_params.ajax_url,
            type:    'POST',
            dataType:'json',
            data: {
                action:         'pos_coupon_create',
                coupon_value:   amount,
                receipt_number: receipt
            },
            success(response) {
                if (!response.success) {
                    const errHtml = response.data.fragments.replace['.general-notices'] || '';
                    const errText = $('<div>'+errHtml+'</div>').text().trim();
                    return alert(errText);
                }

                const newItemHtml = response.data.fragments.replace['.pos__new_coupon'];
                if (newItemHtml) {
                    $('.pos__new_coupon').replaceWith(newItemHtml);
                }
                let code = response.data.code;
                $('.pos__header_info p')
                    .text(`Poukaz ${code} byl úspěšně vygenerován.`);
                $('.pos__header_info')
                    .show()
                    .delay(3000)
                    .fadeOut();
            },
            error() {
                alert('Chyba sítě, zkuste to znovu.');
            }
        });
    });

})(jQuery);
